// M009: per-turn cost badge. Renders as a subtle right-aligned line
// under the agent's message body. Derived from the run_summary
// attachment the orchestrator writes once the turn finishes (mirrors
// turn_usage). Absent while streaming; appears the moment the
// orchestrator flips the turn complete.

import type { AttachmentRow } from "./types";
import {
  parsePayload,
  type RunSummaryPayload,
} from "./AttachmentRenderer";

export function CostBadge({
  attachment,
  messageId,
}: {
  attachment: AttachmentRow;
  messageId: number;
}) {
  const payload = parsePayload<RunSummaryPayload>(attachment.payload_json);
  if (!payload) return null;
  const fail = payload.fail ?? 0;
  const failed = fail > 0;
  const tone = failed ? "text-danger" : "text-faint";
  const durationLabel =
    payload.duration_ms !== undefined && payload.duration_ms > 0
      ? ` · ${(payload.duration_ms / 1000).toFixed(1)}s`
      : "";
  const noteLabel = payload.note ?? "";
  return (
    <p
      className={`mt-1 text-right font-code text-[0.6875rem] ${tone}`}
      data-testid={`cost-badge-${messageId}`}
    >
      {noteLabel}
      {durationLabel}
    </p>
  );
}
